import type { DataErrorRepository } from '../data/data-error-repository';
import type { HandleActionRequest, BatchHandleResultItem } from '../types/data-error-types';

export class BatchHandleIrregularDeltaUseCase {
  constructor(private readonly repository: DataErrorRepository) {}

  async execute(
    items: HandleActionRequest[]
  ): Promise<
    { isSuccess: true; rows: BatchHandleResultItem[] } |
    { isSuccess: false; errorMessage: string }
  > {
    try {
      const result = await this.repository.batchHandleAction({ irregularDeltaItems: items });
      if (!result.isSuccess) {
        return { isSuccess: false, errorMessage: result.errorMessage ?? 'Batch action failed' };
      }
      return { isSuccess: true, rows: result.rows ?? [] };
    } catch (error: unknown) {
      return {
        isSuccess: false,
        errorMessage: error instanceof Error ? error.message : 'Batch action failed',
      };
    }
  }
}
